import styled from 'styled-components';
import { colors } from '../../../theme/theme';

export const ContactButton = styled.div`
  cursor: pointer;
  background: ${colors.mainColors.verde_dstore};
  box-shadow: 0px 0px 6px rgba(55, 200, 150, 0.2);
  position: fixed;
  bottom: 2%;
  font-size: 28px;
  color: ${colors.greyscale.white};
  right: 2%;
  border-radius: 100%;
  width: 50px;
  height: 50px;
  text-align: center;

  &:hover {
    background: ${colors.mainColors.dark_verde_dstore};
  }
`;

export const ContactForm = styled.div`
  background: ${colors.greyscale.white};
  border-radius: 4px;
  box-shadow: 0px 2px 10px 4px rgb(51 51 51 / 15%);
  position: fixed;
  bottom: 10%;
  right: 2%;
  padding: 20px;
`;

export const CloseButton = styled.div`
  position: absolute;
  text-align: end;
  top: 3%;
  right: 2%;
  font-size: 23px;

  svg {
    cursor: pointer;
  }
`;

